import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function FadeIn({ children, delay = 0, y = 28, className = "" }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
    return (
        <span className={`block overflow-hidden ${className}`}>
            <motion.span
                className="block"
                initial={{ y: "115%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1, delay, ease: EASE }}
            >
                {children}
            </motion.span>
        </span>
    );
}

export function MaskedLineInView({ children, delay = 0, className = "" }) {
    return (
        <span className={`block overflow-hidden ${className}`}>
            <motion.span
                className="block"
                initial={{ y: "115%" }}
                whileInView={{ y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.9, delay, ease: EASE }}
            >
                {children}
            </motion.span>
        </span>
    );
}

export function SectionHeading({ eyebrow, title, className = "" }) {
    return (
        <div className={className}>
            <FadeIn>
                <p className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-accent">
                    <span className="h-px w-10 bg-accent" aria-hidden="true" />
                    {eyebrow}
                </p>
            </FadeIn>
            <MaskedLineInView delay={0.1}>
                <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] text-white sm:text-5xl lg:text-6xl">
                    {title}
                </h2>
            </MaskedLineInView>
        </div>
    );
}
